<div class="checkbox" [ngClass]="{active: value}" (click)="toggle()">
  <div class="checkbox__view"></div>
  <div class="checkbox__label">
    <ng-content></ng-content>
  </div>
</div>
